export const returnHypphen = (a: string | null, b: string | null) => {
  if (a && b && a !== '' && b !== '') {
    return '-'
  }
  return
}
